import React from 'react';
import intl from 'react-intl-universal';
import './NewDialog.scss';



export default class NewDialog extends React.Component{
    realOnOk = ()=>{
        if(typeof this.props.onOk === 'function'){
            const result = this.props.onOk();
            //只要不是返回的false，都关闭弹框
            if(false !== result){
                this.props.onCancel();
            }
        }
    }
    render(){
        const {onCancel,className,onMask,showCancel=true,okText,cancelText} = this.props;
        return (
            <div className={"new-dialog-mask "+(className||"")} onClick={onMask}>
                <div className="new-dialog-main" onClick={(e)=>{e.stopPropagation()}}>
                    <div className="content">
                        {this.props.children}
                    </div>

                    <footer className="new-dialog-footer">
                        {showCancel &&<button className="footer-button button1" onClick={onCancel}>{cancelText || intl.get('cancel')}</button>}
                        <button className="footer-button button2" onClick={this.realOnOk}>{okText||intl.get('ok')}</button>
                    </footer>
                </div>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Dialog/NewDialog.js